module.exports = {"name":"ooyala","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.3","built":"2018-05-28","repo":"https://bitbucket.org/npaw/ooyala-adapter-js","libVersion":"6.2.6","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getRendition","getTitle","getIsLive","getResource"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getBitrate","getRendition","getTitle","getResource","getPosition"],"filename":"adsadapter.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 10
// module chunks = 0